import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http"
import {axiosInstance as axios} from "../../utils/axios"
import {SecondaryNav} from "../../models/secondary-nav"
import AppApiConfig from "../../config/api/meganavdata"
import {getTestingVariant} from "../../utils/testingVariant"

export const getSecondaryNavData = async (
    baseUrl: string,
    headers: IncomingHttpHeaders,
    department: string,
    queryParameters: string,
): Promise<SecondaryNav> => {
    try {
        const page = "home" // FIXME hard coded for now until we can dynamically get the page
        const {cookie, ...rest} = headers
        const getAppDataApi = AppApiConfig("getSecondaryNavData")
        const testingVariant = getTestingVariant()
        const processedQueryString = queryParameters ? `?${queryParameters}` : ""
        // This is a HOT FIX to get the cors issue sorted for Home subsite. PBI 3739451 to address to root cause.
        delete rest["x-next-tabbed-navigation"]
        delete rest["x-next-realm-entrypoint"]
        delete rest["x-next-onsite-consent"]

        const response = await axios({
            method: getAppDataApi.method,
            url: `${baseUrl}${getAppDataApi.localEndpoint(page, department, testingVariant)}${processedQueryString}`,
            headers: rest as {
                [header: string]: string
            },
        })

        return new SecondaryNav(response.data as SecondaryNav)
    } catch (ex) {
        logger.error(ex)
        throw ex
    }
}
